<div class="container-fluid p-3">
  <mat-card>
    <mat-card-header class="pb-0">
      <mat-card-title>{{ isEditing ? 'Editar' : 'Crear' }} Tipo de Novedad</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <form [formGroup]="novedadForm" (ngSubmit)="onSubmit()">
        <div class="row g-3 align-items-center">
          <div class="col-12 col-md-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Código</mat-label>
              <input matInput formControlName="codigo" required
                     [readonly]="isEditing"
                     [matTooltip]="isEditing ? 'No se puede modificar el código en modo edición' : ''"
                     [matTooltipPosition]="'above'">
              <mat-error *ngIf="novedadForm.get('codigo')?.hasError('required')">
                El código es requerido
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descripción</mat-label>
              <input matInput formControlName="descripcion" required>
              <mat-error *ngIf="novedadForm.get('descripcion')?.hasError('required')">
                La descripción es requerida
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tipo</mat-label>
              <mat-select formControlName="tipo" required>
                <mat-option *ngFor="let tipo of tiposNovedad" [value]="tipo">
                  {{tipo}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="novedadForm.get('tipo')?.hasError('required')">
                El tipo es requerido
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Aplicable (Días)</mat-label>
              <input matInput type="number" formControlName="apartir_de" required>
              <mat-error *ngIf="novedadForm.get('apartir_de')?.hasError('required')">
                El valor es requerido
              </mat-error>
              <mat-error *ngIf="novedadForm.get('apartir_de')?.hasError('min')">
                El valor debe ser mayor o igual a 0
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="d-flex gap-2 mt-3 justify-content-end">
          <button mat-flat-button color="primary" type="submit" [disabled]="!novedadForm.valid || isLoading"
            class="btn btn-primary">
            <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
            <span *ngIf="!isLoading">{{ isEditing ? 'Actualizar' : 'Guardar' }}</span>
          </button>
          <button mat-flat-button type="button" (click)="resetForm()" *ngIf="isEditing" [disabled]="isLoading"
            class="btn btn-secondary">
            Cancelar
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>Lista de Tipos de Novedad</mat-card-title>
    </mat-card-header>

    <mat-card-content class="pt-3">
      <!-- Barra de búsqueda -->
      <div class="row mb-3">
        <div class="col-md-6 col-sm-12 mb-2 mb-sm-0">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Buscar</mat-label>
            <input matInput [formControl]="searchControl" placeholder="Buscar por descripción o tipo...">
            <mat-icon matSuffix class="text-dark">search</mat-icon>
          </mat-form-field>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="table w-100">
          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 11px;">Código</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">{{element.codigo}}</td>
          </ng-container>

          <ng-container matColumnDef="descripcion">
            <th mat-header-cell *matHeaderCellDef style="width: 30%; font-size: 11px;">Descripción</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">{{element.descripcion}}</td>
          </ng-container>

          <ng-container matColumnDef="tipo">
            <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 11px;">Tipo</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">{{element.tipo}}</td>
          </ng-container>

          <ng-container matColumnDef="apartir_de">
            <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 11px;text-align: center">Aplicable (Días)
            </th>
            <td mat-cell *matCellDef="let element" style="text-align: center; vertical-align: middle; font-size: 11px;">
              {{element.apartir_de}}</td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef style="width: 20%; text-align: center; font-size: 11px;">Acciones</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle;">
              <div style="display: flex; justify-content: center; gap: 4px;">
                <button mat-icon-button color="primary" (click)="editarNovedad(element)" matTooltip="Editar"
                  class="text-dark">
                  <mat-icon style="font-size: 1.3rem;">edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="onDelete(element)" matTooltip="Eliminar"
                  class="text-dark">
                  <mat-icon style="font-size: 1.3rem;">delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="text-center p-3" *ngIf="dataSource.data.length === 0 && !isLoading">
          No hay datos disponibles
        </div>

        <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>